import { render, staticRenderFns } from "./ActionPostbackEmail.vue?vue&type=template&id=949223e8&scoped=true&"
import script from "./ActionPostbackEmail.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackEmail.vue?vue&type=script&lang=js&"
import style0 from "./ActionPostbackEmail.vue?vue&type=style&index=0&id=949223e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949223e8",
  null
  
)

export default component.exports